export const Types = {
    GET_AREA_GROUP_LIST_PLANNED: "GET_AREA_GROUP_LIST_PLANNED",
    SET_AREA_GROUP_LIST_PLANNED: "SET_AREA_GROUP_LIST_PLANNED",

    GET_MAIN_EQUIPMENT_LIST_PLANNED: "GET_MAIN_EQUIPMENT_LIST_PLANNED",
    SET_MAIN_EQUIPMENT_LIST_PLANNED: "SET_MAIN_EQUIPMENT_LIST_PLANNED",

    GET_SUB_EQUIPMENT_LIST_PLANNED: "GET_SUB_EQUIPMENT_LIST_PLANNED",
    SET_SUB_EQUIPMENT_LIST_PLANNED: "SET_SUB_EQUIPMENT_LIST_PLANNED",

    GET_SUB_EQUIPMENTS_TASK_LIST_PLANNED: "GET_SUB_EQUIPMENTS_TASK_LIST_PLANNED",
    SET_SUB_EQUIPMENTS_TASK_LIST_PLANNED: "SET_SUB_EQUIPMENTS_TASK_LIST_PLANNED",

    GET_MAINTENANCE_TYPE_DATA: "GET_MAINTENANCE_TYPE_DATA",
    SET_MAINTENANCE_TYPE_DATA: "SET_MAINTENANCE_TYPE_DATA",

    GET_POOL_DATA: "GET_POOL_DATA",
    SET_POOL_DATA: "SET_POOL_DATA",
}

export const getAreaGroupListPlanned = (payload) => ({
    type: Types.GET_AREA_GROUP_LIST_PLANNED,
    payload,
});

export const setAreaGroupListPlanned = (payload) => ({
    type: Types.SET_AREA_GROUP_LIST_PLANNED,
    payload,
});

export const getMainEquipmentListPlanned = (payload) => ({
    type: Types.GET_MAIN_EQUIPMENT_LIST_PLANNED,
    payload,
});

export const setMainEquipmentListPlanned = (payload) => ({
    type: Types.SET_MAIN_EQUIPMENT_LIST_PLANNED,
    payload,
});

export const getSubEquipmentListPlanned = (payload) => ({
    type: Types.GET_SUB_EQUIPMENT_LIST_PLANNED,
    payload,
});

export const setSubEquipmentListPlanned = (payload) => ({
    type: Types.SET_SUB_EQUIPMENT_LIST_PLANNED,
    payload,
});

export const getSubEquipmentsTaskListPlanned = (payload) => ({
    type: Types.GET_SUB_EQUIPMENTS_TASK_LIST_PLANNED,
    payload,
});

export const setSubEquipmentsTaskListPlanned = (payload) => ({
    type: Types.SET_SUB_EQUIPMENTS_TASK_LIST_PLANNED,
    payload,
});

export const getMaintenanceTypeData = (payload) => ({
    type: Types.GET_MAINTENANCE_TYPE_DATA,
    payload,
});

export const setMaintenanceTypeData = (payload) => ({
    type: Types.SET_MAINTENANCE_TYPE_DATA,
    payload,
});

export const getPoolData = () => ({
    type: Types.GET_POOL_DATA,
});

export const setPoolData = (payload) => ({
    type: Types.SET_POOL_DATA,
    payload,
});
